import { test1 } from "./test/test1";
import { test2 } from "./test/test2";
import { test3 } from "./test/test3";
import { test4 } from "./test/test4";
// 스토리 테스트는 별도 사이트로 분리됨. 다시 넣으려면 아래 import 와 allTest 에 story1 추가
// import { story1 } from "./story/story1";
// import { story2 } from "./story/story2"; // 공개 버튼 앞에서 (교체됨, 파일은 보관)
import { story5 } from "./story/story5";



//카테고리 타입
export const categoryType = [
  { id: 1, name: "방향성" },
  { id: 2, name: "속도" },
  { id: 3, name: "포지셔닝" },
];

/**
 * 모든 테스트 문제들 배열입니다.
 * 여기에 test 추가하시면 됩니다.
 * 1. test는 data/test test1.js 파일과 동일한 데이터 형태로 만들고
 * 2. 맨 위 import로 test1 처럼 imoprt 하시고 배열 안에 넣으시며 됩니다.
 *
 * 만약 question2를 만드신다면 1,2를하시고
 * export const allTest = [test1, test2]; <<----- 이렇게 넣으시면
 * 등록 완료 입니다.
 */
export const allTest = [test1, test2, test3, test4, story5];

// [비공개] 로컬 개발 서버(npm start)에서만 보이는 테스트.
// 실제 사이트 빌드에서는 이 블록이 통째로 빠져서 방문자는 볼 수 없어요.
// 공개하려면: 위 allTest 배열에 넣고 이 블록을 지우면 됩니다.
if (process.env.NODE_ENV === "development") {
  allTest.push(require("./story/story3").story3); // 판매 저항감 (숨김)
}

export const getCategory = (id) => {
  return categoryType.find((item) => item.id === id);
};

// URL 파라미터(문자열)로 테스트를 찾습니다. 없으면 undefined.
export const findTest = (id) => {
  return allTest.find((item) => `${item.id}` === `${id}`);
};

// 같은 카테고리의 다른 테스트 목록
export const getRelatedTests = (test) => {
  return allTest.filter(
    (item) => item.categoryId === test.categoryId && item.id !== test.id
  );
};
